import { render, staticRenderFns } from "./Lgx328506497581449216.vue?vue&type=template&id=6e1b630e&scoped=true&"
import script from "./Lgx328506497581449216.vue?vue&type=script&lang=js&"
export * from "./Lgx328506497581449216.vue?vue&type=script&lang=js&"
import style0 from "./Lgx328506497581449216.vue?vue&type=style&index=0&id=6e1b630e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b630e",
  null
  
)

export default component.exports